import { differenceInDays } from 'date-fns';
import React, { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { DateRange } from 'shared/types/date-range';

import * as Styled from './today-line.style';

export type TodayLineProps = {
  dateRange: DateRange;
  dayWidth: number;
};

export const TodayLine: React.FC<TodayLineProps> = ({
  dateRange,
  dayWidth,
}) => {
  const today = useToday();
  const daysFromStart = useMemo(
    () => differenceInDays(today, dateRange.startDate),
    [dateRange.startDate, today],
  );
  const left = daysFromStart * dayWidth;

  if (left < 0) {
    return null;
  }

  return <Styled.Line $left={left} />;
};
